import { render, staticRenderFns } from "./cms-page-qr-scanner.vue?vue&type=template&id=2b21670c&scoped=true"
import script from "./cms-page-qr-scanner.vue?vue&type=script&lang=js"
export * from "./cms-page-qr-scanner.vue?vue&type=script&lang=js"
import style0 from "./cms-page-qr-scanner.vue?vue&type=style&index=0&id=2b21670c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b21670c",
  null
  
)

export default component.exports